import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "index-panel",
  "aria-label": "Reverse index"
}
const _hoisted_2 = { class: "panel-head" }
const _hoisted_3 = { class: "panel-actions" }
const _hoisted_4 = { class: "direction" }
const _hoisted_5 = { class: "word" }
const _hoisted_6 = {
  key: 0,
  class: "translit"
}
const _hoisted_7 = {
  key: 0,
  class: "gloss"
}
const _hoisted_8 = {
  key: 1,
  class: "here"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "unconfirmed"
}
const _hoisted_11 = { class: "tabs-bar" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "panel-body"
}
const _hoisted_14 = {
  key: 0,
  class: "muted"
}
const _hoisted_15 = {
  key: 1,
  class: "muted"
}
const _hoisted_16 = {
  key: 0,
  class: "muted"
}
const _hoisted_17 = {
  key: 1,
  class: "panel-body"
}
const _hoisted_18 = {
  key: 0,
  class: "muted"
}
const _hoisted_19 = {
  key: 1,
  class: "muted"
}
const _hoisted_20 = { class: "consistency" }
const _hoisted_21 = { class: "font-greek column-name" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "muted share" }
const _hoisted_25 = {
  key: 1,
  class: "muted n",
  title: "distinct Greek words"
}
const _hoisted_26 = {
  key: 0,
  class: "muted"
}
const _hoisted_27 = {
  key: 2,
  class: "panel-body"
}
const _hoisted_28 = {
  key: 0,
  class: "muted"
}
const _hoisted_29 = {
  key: 1,
  class: "muted"
}
const _hoisted_30 = { class: "muted total" }
const _hoisted_31 = { class: "column-name font-greek" }
const _hoisted_32 = { class: "muted" }
const _hoisted_33 = { class: "rendering" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "gloss"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "unconfirmed-count",
  title: "unconfirmed"
}
const _hoisted_38 = {
  key: 0,
  class: "unaligned"
}
const _hoisted_39 = { class: "muted" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "muted" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LexiconCard = _resolveComponent("LexiconCard")!
  const _component_AgreementTable = _resolveComponent("AgreementTable")!
  const _component_RefList = _resolveComponent("RefList")!

  return (_ctx.opened)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.canGoBack)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "plain",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
                  "aria-label": "Back"
                }, "←"))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.direction), 1),
            _createElementVNode("button", {
              class: "plain close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeIndex && _ctx.closeIndex(...args))),
              "aria-label": "Close"
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["headword", _ctx.font(_ctx.opened.lexeme)])
            }, _toDisplayString(_ctx.opened.lexeme.headword), 3),
            (_ctx.opened.lexeme.translit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.opened.lexeme.translit), 1))
              : _createCommentVNode("", true),
            (_ctx.opened.surface !== _ctx.opened.lexeme.headword)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["surface", _ctx.font(_ctx.opened.lexeme)])
                }, "(" + _toDisplayString(_ctx.opened.surface) + ")", 3))
              : _createCommentVNode("", true)
          ]),
          (_ctx.opened.lexeme.gloss)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.opened.lexeme.gloss), 1))
            : _createCommentVNode("", true),
          (_ctx.opened.counterpart.length && _ctx.info.relation)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" Here it " + _toDisplayString(_ctx.info.relation) + " ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opened.counterpart, (c) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: c.key,
                    class: _normalizeClass(_ctx.font(c)),
                    onClick: ($event: any) => (_ctx.pivot(c))
                  }, _toDisplayString(c.headword), 11, _hoisted_9))
                }), 128)),
                (!_ctx.opened.confident)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(unconfirmed)"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("nav", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
            return (_openBlock(), _createElementBlock("button", {
              key: t.id,
              class: _normalizeClass(["tab", { 'is-active': _ctx.tab === t.id }]),
              onClick: ($event: any) => (_ctx.tab = t.id)
            }, _toDisplayString(t.label), 11, _hoisted_12))
          }), 128))
        ]),
        (_ctx.tab === 'lexicons')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.layerLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Loading…"))
                : (_ctx.layerError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.layerError), 1))
                  : (_ctx.layer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (!_ctx.layer.cards.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "No lexicon has an entry for this word."))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layer.cards, (c, i) => {
                          return (_openBlock(), _createBlock(_component_LexiconCard, {
                            key: i,
                            card: c,
                            onOpenStrongs: _ctx.openStrongs
                          }, null, 8, ["card", "onOpenStrongs"]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
            ]))
          : (_ctx.tab === 'translators')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_ctx.layerLoading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Loading…"))
                  : (_ctx.layerError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.layerError), 1))
                    : (_ctx.layer)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "section" }, "How each column renders it", -1)),
                          _createElementVNode("table", _hoisted_20, [
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layer.consistency, (c) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: c.column
                                }, [
                                  _createElementVNode("td", _hoisted_21, _toDisplayString(c.column), 1),
                                  (c.lexemes[0])
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                        _createElementVNode("a", {
                                          class: "font-greek",
                                          onClick: ($event: any) => (_ctx.pivot(c.lexemes[0].dominant))
                                        }, _toDisplayString(c.lexemes[0].dominant.headword), 9, _hoisted_23),
                                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.percent(c.lexemes[0].dominant_share)) + " of " + _toDisplayString(c.lexemes[0].total), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (c.lexemes[0])
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(c.lexemes[0].distinct) + " " + _toDisplayString(c.lexemes[0].distinct === 1 ? 'word' : 'words'), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]),
                          (!_ctx.layer.consistency.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Not a content word, or not rendered."))
                            : _createCommentVNode("", true),
                          (_ctx.layer.agreement && _ctx.layer.agreement.pairs.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "section" }, "How the columns agree at it", -1)),
                                _createVNode(_component_AgreementTable, {
                                  pairs: _ctx.layer.agreement.pairs,
                                  scope: { hebrew: _ctx.opened.lexeme.key }
                                }, null, 8, ["pairs", "scope"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Loading…"))
                  : (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.error), 1))
                    : (_ctx.data)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.data.total) + " occurrences", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.columns, (c) => {
                            return (_openBlock(), _createElementBlock("section", {
                              key: c.column,
                              class: "column"
                            }, [
                              _createElementVNode("h3", null, [
                                _createElementVNode("span", _hoisted_31, _toDisplayString(c.column), 1),
                                _createElementVNode("span", _hoisted_32, _toDisplayString(c.total), 1)
                              ]),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shown(c), (r) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: r.lexeme.key
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("a", {
                                        class: _normalizeClass(["lexeme", _ctx.font(r.lexeme)]),
                                        onClick: ($event: any) => (_ctx.pivot(r.lexeme))
                                      }, _toDisplayString(r.lexeme.headword), 11, _hoisted_34),
                                      (r.lexeme.gloss)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(r.lexeme.gloss), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("button", {
                                        class: "count",
                                        onClick: ($event: any) => (_ctx.toggleRefs(c.column, r.lexeme.key))
                                      }, [
                                        _createTextVNode(_toDisplayString(r.count), 1),
                                        (r.unconfirmed)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "·" + _toDisplayString(r.unconfirmed) + "?", 1))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_36)
                                    ]),
                                    (_ctx.refsOpen === _ctx.refKey(c.column, r.lexeme.key))
                                      ? (_openBlock(), _createBlock(_component_RefList, {
                                          key: 0,
                                          language: _ctx.language,
                                          lexeme: _ctx.opened.lexeme.key,
                                          column: c.column,
                                          counterpart: r.lexeme.key,
                                          origin: "head"
                                        }, null, 8, ["language", "lexeme", "column", "counterpart"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                (c.unaligned)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.info.unaligned), 1),
                                      _createElementVNode("button", {
                                        class: "count",
                                        onClick: ($event: any) => (_ctx.toggleRefs(c.column, null))
                                      }, _toDisplayString(c.unaligned), 9, _hoisted_40),
                                      (_ctx.refsOpen === _ctx.refKey(c.column, null))
                                        ? (_openBlock(), _createBlock(_component_RefList, {
                                            key: 0,
                                            language: _ctx.language,
                                            lexeme: _ctx.opened.lexeme.key,
                                            column: c.column,
                                            counterpart: null,
                                            origin: "head"
                                          }, null, 8, ["language", "lexeme", "column"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beyond(c), (b) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: b.origin,
                                    class: "beyond"
                                  }, [
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(b.label), 1),
                                    _createElementVNode("button", {
                                      class: "count",
                                      onClick: ($event: any) => (_ctx.toggleRefs(c.column, null, b.origin))
                                    }, _toDisplayString(b.count), 9, _hoisted_42),
                                    (_ctx.refsOpen === _ctx.refKey(c.column, null, b.origin))
                                      ? (_openBlock(), _createBlock(_component_RefList, {
                                          key: 0,
                                          language: _ctx.language,
                                          lexeme: _ctx.opened.lexeme.key,
                                          column: c.column,
                                          counterpart: null,
                                          origin: b.origin
                                        }, null, 8, ["language", "lexeme", "column", "origin"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              (c.renderings.length > _ctx.limit && !_ctx.expanded.includes(c.column))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "plain more",
                                    onClick: ($event: any) => (_ctx.expanded.push(c.column))
                                  }, _toDisplayString(c.renderings.length - _ctx.limit) + " more ", 9, _hoisted_43))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true)
              ]))
      ]))
    : _createCommentVNode("", true)
}